module.exports = __webpack_public_path__ + "static/img/industry_common.cc14c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_common.jpg
// module id = JaXF
// module chunks = 0